import React from "react";

export default function TableHistoryillness() {
  return <div className="box_table_history_illness"></div>;
}
